import { Route, Routes, useMatch } from "react-router-dom";
import Evento from "../Screens/Evento/Evento";
import Campus from "../Screens/Campus/Campus";
import Busqueda from "../Screens/Busqueda/Busqueda";
import Error404 from "../Screens/Inicio/404";
import Gracias from "../Screens/Gracias/Gracias";

export default function AppRouter() {
  const env = process.env.REACT_APP_ADM_ENV;
  const pathRoot = env === "prod_server" ? "/:param1/" : "/:param1/:param2/";

  return (
    <>
      <Routes>
        <Route exact path={pathRoot + ":eventId"} element={<Evento />} />
        <Route exact path={pathRoot + ":eventId/gracias"} element={<Evento />} />
        <Route exact path={pathRoot + "gracias"} element={<Gracias />} />
        <Route exact path={pathRoot + "latam/:campusId"} element={<Campus />} />
        <Route exact path={pathRoot + "busqueda"} element={<Busqueda />} />
        <Route path={pathRoot + "*"} element={<Error404Route />} />
        <Route path={pathRoot} element={<Error404Route />} />
      </Routes>
    </>
  );
}

function Error404Route() {
  const match = useMatch("/*");
  return <Error404 path={match?.params["*"]} />;
}
